import * as tslib_1 from "tslib";
import { Api } from '../api/api';
import { environment } from '../environment';
import { PetlService } from './petl.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/api";
import * as i2 from "./petl.service";
var petlDisplayStart = 100;
var LayerCatalogService = /** @class */ (function () {
    function LayerCatalogService(api, petlService) {
        this.api = api;
        this.petlService = petlService;
        this.catalogItems = new Array();
        this.categoryCatalogItemsDictionary = {};
        this.unparentedCategories = new Array();
    }
    LayerCatalogService.prototype.getApplicationCategoryLayers = function (appId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                    query {\n                        categories {\n                            displayOrder\n                            id\n                            parentId\n                            name\n                        }\n                        applicationCategoryLayers(applicationId: " + appId + ") {\n                            categoryId\n                            displayOrder\n                            layerId\n                            layer {\n                                id\n                                name\n                                description\n                                isSystem\n                            }\n                        }\n                    }\n        ", {})];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerCatalogService.prototype.getUserLayers = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query {\n                users(id: " + userId + ") {\n                    userLayers {\n                        layer(typeId: 3) {\n                        id name typeId sources {id, sourceType}                             \n                        }\n                    }\n                }\n            }\n        ", {})];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerCatalogService.prototype.getUserLayerCatalog = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, result, userLayerCatalogItems, layers, layers_1, layers_1_1, layer, layerCatalogItem;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getUserLayers(userId)];
                    case 1:
                        result = _b.sent();
                        userLayerCatalogItems = [];
                        if (result.users.length > 0) {
                            layers = result.users[0].userLayers.filter(function (x) { return x.layer; }).map(function (x) { return x.layer; });
                            try {
                                for (layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                                    layer = layers_1_1.value;
                                    layerCatalogItem = { name: layer.name, layer: layer };
                                    userLayerCatalogItems.push(layerCatalogItem);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        return [2 /*return*/, userLayerCatalogItems];
                }
            });
        });
    };
    LayerCatalogService.prototype.generateCatalog = function (appId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchCatalogData(appId)];
                    case 1:
                        _a.sent();
                        this.resetCatalogCollections();
                        this.placeCategoriesInCatalog();
                        this.placeLayersInCatalog();
                        this.removeCategoriesWithNoLayers();
                        return [2 /*return*/, this.catalogItems];
                }
            });
        });
    };
    LayerCatalogService.prototype.fetchCatalogData = function (appId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, _b, result, _loop_1, this_1, _c, _d, appCategoryLayer, petlCategory, petlProjects, newCatalogItems;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.getApplicationCategoryLayers(appId)];
                    case 1:
                        result = _e.sent();
                        this.appCategoriesLayers = result.applicationCategoryLayers.filter(function (acl) { return acl.layer !== null && acl.layer.isSystem; });
                        this.categories = result.categories;
                        _loop_1 = function (appCategoryLayer) {
                            appCategoryLayer.category = this_1.categories.find(function (c) { return c.id === appCategoryLayer.categoryId; });
                        };
                        this_1 = this;
                        try {
                            for (_c = tslib_1.__values(this.appCategoriesLayers), _d = _c.next(); !_d.done; _d = _c.next()) {
                                appCategoryLayer = _d.value;
                                _loop_1(appCategoryLayer);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        petlCategory = this.categories.find(function (c) { return c.id === environment.petlCategoryId; });
                        if (!petlCategory) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.petlService.getProjectList()];
                    case 2:
                        petlProjects = _e.sent();
                        newCatalogItems = petlProjects.map(function (pr, i) {
                            return {
                                categoryId: petlCategory.id,
                                category: {
                                    name: petlCategory.name,
                                    id: petlCategory.id
                                },
                                displayOrder: i + petlDisplayStart,
                                layer: {
                                    id: pr.id,
                                    name: pr.description
                                },
                                layerId: pr.id
                            };
                        });
                        (_b = this.appCategoriesLayers).push.apply(_b, tslib_1.__spread(newCatalogItems));
                        _e.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogService.prototype.resetCatalogCollections = function () {
        this.catalogItems = new Array();
        this.categoryCatalogItemsDictionary = {};
        this.unparentedCategories = this.categories.concat([]);
    };
    LayerCatalogService.prototype.placeCategoriesInCatalog = function () {
        var e_3, _a;
        var searchDepthMax = 10;
        var depth = 0;
        while (depth < searchDepthMax && this.getUnparentedCategoriesArray().length > 0) {
            var unparentedCategoriesCopy = this.unparentedCategories.concat([]);
            this.unparentedCategories = [];
            try {
                for (var unparentedCategoriesCopy_1 = tslib_1.__values(unparentedCategoriesCopy), unparentedCategoriesCopy_1_1 = unparentedCategoriesCopy_1.next(); !unparentedCategoriesCopy_1_1.done; unparentedCategoriesCopy_1_1 = unparentedCategoriesCopy_1.next()) {
                    var category = unparentedCategoriesCopy_1_1.value;
                    this.placeCategoryInCatalog(category);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (unparentedCategoriesCopy_1_1 && !unparentedCategoriesCopy_1_1.done && (_a = unparentedCategoriesCopy_1.return)) _a.call(unparentedCategoriesCopy_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            depth++;
        }
    };
    LayerCatalogService.prototype.getUnparentedCategoriesArray = function () {
        return this.unparentedCategories;
    };
    LayerCatalogService.prototype.placeLayersInCatalog = function () {
        var e_4, _a;
        try {
            for (var _b = tslib_1.__values(this.appCategoriesLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var appCategoriesLayer = _c.value;
                if (appCategoriesLayer.layer) {
                    try {
                        var categoryCatalogItem = this.categoryCatalogItemsDictionary[appCategoriesLayer.categoryId];
                        if (!categoryCatalogItem.layerCatalogItems) {
                            categoryCatalogItem.layerCatalogItems = [];
                        }
                        var layerCatalogItem = {
                            displayOrder: appCategoriesLayer.displayOrder,
                            id: appCategoriesLayer.layer.id,
                            name: appCategoriesLayer.layer.name,
                            layer: appCategoriesLayer.layer,
                            description: appCategoriesLayer.layer.description
                        };
                        if (categoryCatalogItem.id === environment.petlCategoryId && layerCatalogItem.displayOrder >= petlDisplayStart) {
                            layerCatalogItem.ispetl = true;
                        }
                        categoryCatalogItem.layerCatalogItems.push(layerCatalogItem);
                    }
                    catch (error) {
                        console.error('Error found when creating layer in layer catalog');
                    }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    LayerCatalogService.prototype.removeCategoriesWithNoLayers = function () {
        this.catalogItems = this.removeEmptyBranchesAndSort(this.catalogItems);
    };
    LayerCatalogService.prototype.removeEmptyBranchesAndSort = function (list) {
        var e_5, _a;
        var newList = [];
        try {
            for (var list_1 = tslib_1.__values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                var item = list_1_1.value;
                if (item.layerCatalogItems) {
                    item.layerCatalogItems = this.removeEmptyBranchesAndSort(item.layerCatalogItems);
                }
                if (item.layer || item.layerCatalogItems) {
                    newList.push(item);
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        if (newList.length > 0) {
            this.sortLayerCatalogItems(newList);
            return newList;
        }
        else {
            return null;
        }
    };
    LayerCatalogService.prototype.sortLayerCatalogItems = function (list) {
        list.sort(function (a, b) {
            if (a.displayOrder < b.displayOrder) {
                return -1;
            }
            else if (a.displayOrder > b.displayOrder) {
                return 1;
            }
            else {
                return a.name.localeCompare(b.name);
            }
        });
    };
    LayerCatalogService.prototype.placeCategoryInCatalog = function (category) {
        var categoryCatalogItem = this.categoryCatalogItemsDictionary[category.id];
        if (!categoryCatalogItem) {
            categoryCatalogItem = { displayOrder: category.displayOrder, id: category.id, name: category.name };
            this.categoryCatalogItemsDictionary[category.id] = categoryCatalogItem;
        }
        if (!category.parentId) {
            this.catalogItems.push(categoryCatalogItem);
        }
        else {
            var parentCatalogItem = this.categoryCatalogItemsDictionary[category.parentId];
            if (!parentCatalogItem) {
                this.unparentedCategories.push(category);
            }
            else {
                if (!parentCatalogItem.layerCatalogItems) {
                    parentCatalogItem.layerCatalogItems = [];
                }
                parentCatalogItem.layerCatalogItems.push(categoryCatalogItem);
            }
        }
    };
    LayerCatalogService.prototype.getExternalLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query {\n                mapServers\n            }\n        ", {}, 'GET', 'mapServers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerCatalogService.ngInjectableDef = i0.defineInjectable({ factory: function LayerCatalogService_Factory() { return new LayerCatalogService(i0.inject(i1.Api), i0.inject(i2.PetlService)); }, token: LayerCatalogService, providedIn: "root" });
    return LayerCatalogService;
}());
export { LayerCatalogService };
